import getIgnoreTokenHeader from 'lowcode/utils/service/getIgnoreTokenHeader';
import { baseUrl } from '../util';
import request from '@/utils/request';

export const getProductFaq = (params: any, locale: string) => {
    return request(`${baseUrl(locale)}/faqInfoForWeb/faqInfo/v2/bySpuId`, {
        method: 'get',
        params,
        headers: {
            ...getIgnoreTokenHeader(),
        },
    });
};
